import React from 'react';
import PropTypes from 'prop-types';

import {styled} from "@mui/material/styles";

import {ReactComponent as Trash} from "assets/img/trash.svg";
import {greyishBlue300} from "assets/jss/main";

TrashIcon.propTypes = {
    color: PropTypes.string,
    disabled: PropTypes.bool,
    size: PropTypes.number
};

const StyledSvg = styled(Trash)(({ theme, color, disabled, size}) => ({
    ...size && {
        width: size,
        height: size
    },
    'path': {
        ...color !== null && {
            stroke: color
        },
        ...disabled === true &&  {
            stroke: greyishBlue300
        }
    },
}));

export default function TrashIcon(props) {
    return <StyledSvg {...props} />
}
